import Molde from "./MoldeTourTradicional";
import CardLugar from "../common/card/CardLugar";
import CardRecomienda from "../common/card/CardRecomienda";
import CardCaracteristica from "../common/card/CardCaracteristica";
import CardItinerario from "../common/card/CardItinerario";
import React from 'react';


export default function Citytour() {
  return (
    <>
      <Molde
        image={"/images/city_tour.jpg"}
        title={"CITY TOUR"}
        subtitle={"(Mañana)"}
        description={
          "Este fabuloso tour lo llevara por todos los sitios arquelogicos  más importantes de Cusco. templo de Qoricancha  y los cuatro  sitios arquelogicos mas importates  que se encuentran fuera de la ciudad (SACSAYHUAMAN, QENQO, PUKAPUKARA, TAMBOMACHAY) se puede ver una increíble mezcla de arquitectura, astronomia e  ingenieria del periodo inka  y paisajes hermosos   , en el caso del Qoricancha  se podra observar la fusion de las dos culturas  inka y española. Cusco es verdaderamente un lugar fascinante para recorrer sus hermosas calles y visitar sus imponentes templos coloniales, la ciudad tiene una apariencia que es completamente diferente al resto de las ciudades del Perú. Este recorrido es imprescindible cuando se visita Cusco y suele ser uno de los primeros puertos de escala para todos los turistas visitante nacional y extranjero."
        }
        linkForm={"/reservar/citytour-dia"}
        tipoprecio={"Precio por persona"}
        monto={"US$ 11.00"}
        moneda={"DOLARES"}
        picture1={            
          <>
          <div>
            <CardItinerario
              num="01"
              title="INICIO"
              lugar="Q'ORICANCHA"
              ></CardItinerario>

              <div className="pt-4 grid grid-cols-1 lg:grid-cols-3 p-2 lg:gap-4 gap-2 bg-primary-100">
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/qori-1.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/qori-2.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/qori-3.png`} alt="" />
              </div>
          </div>
          </>
        }

        picture2={            
          <>
          <div>
            <CardItinerario
              num="02"
              title="PARADA"
              lugar="SAYSAQHUAMAN"
              ></CardItinerario>
              <div className="pt-4 grid grid-cols-1 lg:grid-cols-3 p-2 lg:gap-4 gap-2 bg-primary-100">
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/sacsa-1.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/sacsa-2.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/sacsa-3.png`} alt="" />
              </div>
            </div>
          </>
        }

        picture3={            
          <>
          <div>
            <CardItinerario
              num="03"
              title="PARADA"
              lugar="CRISTO BLANCO"
              ></CardItinerario>
              <div className="pt-4 grid grid-cols-1 lg:grid-cols-3 p-2 lg:gap-4 gap-2 bg-primary-100">
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/cris-1.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/cris-2.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/cris-3.png`} alt="" />
              </div>
            </div>
          </>
        }

        picture4={            
          <>
          <div>
            <CardItinerario
              num="04"
              title="PARADA"
              lugar="BOSQUE DE EUCALIPTO"
              ></CardItinerario>
              <div className="pt-4 grid grid-cols-1 lg:grid-cols-3 p-2 lg:gap-4 gap-2 bg-primary-100">
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/bos-1.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/bos-2.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/bos-3.png`} alt="" />
              </div>
            </div>
          </>
        }

        picture5={            
          <>
          <div>
            <CardItinerario
              num="05"
              title="PARADA"
              lugar="Q'ENQO"
              ></CardItinerario>
              <div className="pt-4 grid grid-cols-1 lg:grid-cols-3 p-2 lg:gap-4 gap-2 bg-primary-100">
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/qenqo-1.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/qenqo-2.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/qenqo-3.png`} alt="" />
              </div>
            </div>
          </>
        }

        picture6={            
          <>
          <div>
            <CardItinerario
              num="06"
              title="PARADA"
              lugar="FOTOS CON ALPACAS"
              ></CardItinerario>
              <div className="pt-4 grid grid-cols-1 lg:grid-cols-3 p-2 lg:gap-4 gap-2 bg-primary-100">
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/huaylla-1.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/huaylla-2.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/huaylla-3.png`} alt="" />
              </div>
            </div>
          </>
        }

        picture7={            
          <>
          <div>
            <CardItinerario
              num="07"
              title="PARADA"
              lugar="PUCA PUCARA"
              ></CardItinerario>
              <div className="pt-4 grid grid-cols-1 lg:grid-cols-3 p-2 lg:gap-4 gap-2 bg-primary-100">
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/puca-1.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/puca-2.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/puca-3.png`} alt="" />
              </div>
            </div>
          </>
        }

        picture8={            
          <>
          <div>
            <CardItinerario
              num="08"
              title="PARADA"
              lugar="TAMBOMACHAY"
              ></CardItinerario>
              <div className="pt-4 grid grid-cols-1 lg:grid-cols-3 p-2 lg:gap-4 gap-2 bg-primary-100">
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/tambo-1.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/tambo-2.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/tambo-3.png`} alt="" />
              </div>
            </div>
          </>
        }

        incluye={
          <>
            <p className="text-primary-800 font-light">Transporte turistico</p>
            <p className="text-primary-800 font-light">Guia profesional</p>
            <p className="text-primary-800 font-light">Asistencia permanente</p>
          </>
        }
        noIncluye={
          <>
            <p className="text-primary-800 font-light">Ingreso a koricancha </p>
            <p className="text-primary-800 font-light">Boleto turistico </p>
            <p className="text-primary-800 font-light">Gastos extra</p>
          </>
        }
        caracteristica={
          <>
            <CardCaracteristica
              icon={`${process.env.PUBLIC_URL}/icons/level.svg`}
              title={"Dificultad"}
              desc={"Facil"}
            />
            <CardCaracteristica
              icon={`${process.env.PUBLIC_URL}/icons/compartido.svg`}
              title={"Tipo Servicio"}
              desc={"Compartido"}
            />
            <CardCaracteristica
              icon={`${process.env.PUBLIC_URL}/icons/duracion.svg`}
              title={"Duración"}
              desc={"4 Horas"}
            />
            <CardCaracteristica
              icon={`${process.env.PUBLIC_URL}/icons/cultural.svg`}
              title={"Tipo de Tour"}
              desc={"Cultural"}
            />
          </>
        }
        lugarvisita={
          <>
            <CardLugar
              icon={"01"}
              title={"Q'oricancha"}
            />
            <CardLugar
              icon={"02"}
              title={"Sacsayhuaman"}
            />
            <CardLugar
              icon={"03"}
              title={"Cristo blanco"}
            />
            <CardLugar
              icon={"04"}
              title={"Bosque de eucalipto"}
            />
            <CardLugar
              icon={"05"}
              title={"Qenqo"}
            />
            <CardLugar
              icon={"06"}
              title={"Fotos con alpacas"}
            />
            <CardLugar
              icon={"07"}
              title={"Tambomachay"}
            />
            <CardLugar
              icon={"08"}
              title={"Puka pukara"}
            />
          </>
        }
        TourRecomienda={
          <>
            <CardRecomienda
              img={"/images/montania_colores.png"}
              title={"MONTAÑA 7 COLORES"}
              puntuacion={"4.5"}
              link={'/tour-tradicional/montania-colores'}
            />
            <CardRecomienda
              img={"/images/valle-vip-5.png"}
              title={"VALLE VIP"}
              puntuacion={"5"}
              link={'/tour-tradicional/valle-vip'}
            />
            <CardRecomienda
              img={"/images/laguna_huamantay.png"}
              title={"LAGUNA HUAMANTAY"}
              puntuacion={"5"}
              link={'/tour-tradicional/laguna-huamantay'}
            />
            <CardRecomienda
              img={"/images/maras-moray-4.png"}
              title={"MARAS-MORAY"}
              puntuacion={"4.5"}
              link={'/tour-tradicional/maras-moray'}
            />
          </>
        }
      />
    </>
  );
}
